import { AxiosError } from "axios";
import { ScheduleConflictItem } from "@myapp/contract";

export function parseCompletedBlockersFromError(error: unknown): ScheduleConflictItem[] | null {
  if (!(error instanceof AxiosError)) return null;
  if (error.response?.status !== 409) return null;
  const data = error.response.data as { error?: string; data?: unknown };
  if (data?.error !== "SCHEDULE_COMPLETED_BLOCKERS") return null;
  if (!Array.isArray(data?.data)) return null;
  return data.data as ScheduleConflictItem[];
}
